import GLOBAL from './global';

const match = (name: string, ignore: any) => {
    if (name) {
        if (ignore) {
            const length = ignore.length;
            for (let i = 0; i < length; i++) {
                if (typeof ignore[i] === 'object' && ignore[i].test(name) === true) {
                    return true;
                } else if (name.indexOf(ignore[i]) > -1) {
                    return true;
                }
            }
        }
        return false;
    } else {
        return true;
    }
};

const isMobile = GLOBAL.navigator.userAgent.match('iPhone')
    || GLOBAL.navigator.userAgent.match('Android');

const mergeIgnoreList = (customIgnore?: any) => {
    let mergedIgnoreList: string[] = ['dreport.meituan.net']; // 修复perf
    if (GLOBAL.__prajnaHosts) {
        mergedIgnoreList = mergedIgnoreList.concat(GLOBAL.__prajnaHosts);
    }
    if (GLOBAL.__catHosts) {
        mergedIgnoreList = mergedIgnoreList.concat(GLOBAL.__catHosts);
    }
    if (GLOBAL.__lxHosts) {
        mergedIgnoreList = mergedIgnoreList.concat(GLOBAL.__lxHosts);
    }
    if (GLOBAL.__perfHosts) {
        mergedIgnoreList = mergedIgnoreList.concat(GLOBAL.__perfHosts);
    }
    const ignore: any = {
        resource: mergedIgnoreList,
        xhr: mergedIgnoreList,
    };
    if (customIgnore) {
        if (customIgnore.resource) {
            ignore.resource = ignore.resource.concat(customIgnore.resource);
        }
        if (customIgnore.xhr) {
            ignore.xhr = ignore.xhr.concat(customIgnore.xhr);
        }
    }
    if (GLOBAL.__prajnaIgnore__) {
        if (GLOBAL.__prajnaIgnore__.resource) {
            ignore.resource = ignore.resource.concat(GLOBAL.__prajnaIgnore__.resource);
        }
        if (GLOBAL.__prajnaIgnore__.xhr) {
            ignore.xhr = ignore.xhr.concat(GLOBAL.__prajnaIgnore__.xhr);
        }
    }
    return ignore;
};

const getPageId = (pageId?: string) => {
    if (pageId) {
        return pageId;
    }
    try {
        let pathname = location.pathname;
        let hashname = location.hash;
        const slashIndex = pathname.lastIndexOf('/');
        if (slashIndex > -1) {
            pathname = pathname.substr(slashIndex + 1, pathname.length - slashIndex - 1);
        }
        const htmlIndex = pathname.indexOf('.');
        if (htmlIndex > -1) {
            pathname = pathname.substr(0, htmlIndex);
        }
        if (hashname) {
            if (hashname.startsWith('#/')) {
                hashname = hashname.substr(2, hashname.length - 2);
            } else {
                hashname = hashname.substr(1, hashname.length - 1);
            }
        }
        if (pathname && hashname) {
            return `${pathname}-${hashname}`;
        }
        return pathname || hashname;
    } catch {
        return '';
    }
};

export { match, isMobile, mergeIgnoreList, getPageId };



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/util/utils.ts